import { useState } from "react";

export function ChargeTotpModal({
  onSubmit,
  onClose,
  error,
  isSubmitting,
  title = "Enter your authenticator code",
  subtitle = "Charging requires a 6-digit code from your authenticator app.",
  submitLabel = "Confirm charge",
}: {
  onSubmit: (code: string) => void;
  onClose: () => void;
  error?: string;
  isSubmitting?: boolean;
  title?: string;
  subtitle?: string;
  submitLabel?: string;
}) {
  const [code, setCode] = useState("");
  const valid = /^\d{6}$/.test(code);
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full">
        <h3 className="text-lg font-semibold mb-2">{title}</h3>
        <p className="text-sm text-gray-500 mb-4">{subtitle}</p>
        <input
          autoFocus
          inputMode="numeric"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          onKeyDown={(e) => {
            if (e.key === "Enter" && valid && !isSubmitting) onSubmit(code);
          }}
          placeholder="123456"
          className="w-full px-3 py-2 text-center text-2xl tracking-widest border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
        />
        {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
        <div className="flex gap-3 justify-end mt-4">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 text-sm rounded-md bg-gray-100 text-gray-700 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={() => onSubmit(code)}
            disabled={!valid || isSubmitting}
            className="px-4 py-2 text-sm rounded-md bg-black text-white font-semibold disabled:opacity-50"
          >
            {isSubmitting ? "Verifying..." : submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
